module.exports = __webpack_public_path__ + "img/mq4.c7a733d0.png";